import React, { useState, useEffect, useCallback, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

import './App.css';
import './AthosDark.css';

import HomePage from './HomePage.js';
import NavbarComponent from './NavbarComponent.js';
import FooterComponent from './FooterComponent.js';

import ScrollToTop from './ScrollToTop';

const AboutPage = lazy(() => import('./AboutPage.js'));
const ContactPage = lazy(() => import('./ContactPage.js'));
const Portfolio = lazy(() => import('./Portfolio.js'));
const NotFoundPage = lazy(() => import('./NotFoundPage.js'));

const LoadingFallback = () => (
  <div style={{ textAlign: 'center', padding: '120px 50px', background: '#080c12', minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ width: '24px', height: '24px', border: '2px solid rgba(58,134,255,0.2)', borderTopColor: '#3a86ff', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
  </div>
);

function App() {
  // Always use dark mode for Athos Dark theme
  const darkMode = true;
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleScroll = useCallback(() => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  }, []);

  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth <= 768);
    if (window.innerWidth > 768) {
      setMobileMenuOpen(false);
    }
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [darkMode, handleScroll, handleResize]);

  

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <NavbarComponent 
          darkMode={darkMode} 
          toggleMobileMenu={toggleMobileMenu} 
          mobileMenuOpen={mobileMenuOpen} 
          scrolled={scrolled} 
          isMobile={isMobile} 
        />
        
        {/* Mobile Menu */}
        <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <Link 
            to="/" 
            className={`mobile-nav-link`}
            onClick={toggleMobileMenu}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`mobile-nav-link`}
            onClick={toggleMobileMenu}
          >
            About Me
          </Link>
          <Link 
            to="/portfolio" 
            className={`mobile-nav-link`}
            onClick={toggleMobileMenu}
          >
            Portfolio
          </Link>
          <Link
            to="/contact"
            className={`mobile-nav-link`}
            onClick={toggleMobileMenu}
          >
            Contact
          </Link>
          <a
            href={`${process.env.PUBLIC_URL}/Miles Childress MIS RESUME 2025.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            download="Miles_Childress_Resume.pdf"
            className="mobile-nav-link"
            onClick={toggleMobileMenu}
          >
            Resume
          </a>
        </div>

        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<HomePage darkMode={darkMode} />} />
            <Route path="/about" element={<AboutPage darkMode={darkMode} />} />
            <Route path="/contact" element={<ContactPage darkMode={darkMode} />} />
            <Route path="/portfolio" element={<Portfolio darkMode={darkMode} />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
        
        <FooterComponent />
      </div>
    </BrowserRouter>
  );
}

export default App;